import { render, staticRenderFns } from "./BusAuthorization.vue?vue&type=template&id=5ef6cd45"
import script from "./BusAuthorization.vue?vue&type=script&lang=js"
export * from "./BusAuthorization.vue?vue&type=script&lang=js"
import style0 from "./BusAuthorization.vue?vue&type=style&index=0&id=5ef6cd45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports